import { render, staticRenderFns } from "./NormalSearchNav120.vue?vue&type=template&id=2ef524f4&scoped=true&"
import script from "./NormalSearchNav120.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav120.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef524f4",
  null
  
)

export default component.exports